import { updateObject } from './../../utils/utility';
import { format } from 'date-fns';

const initialState = {
    customerEntities: {},
    customerEntityDetails: {
        companyName: "",
        orgId: "",
        createdDate: format(new Date(), 'MM-dd-yyyy'),
        legalEntityList: []
    },
    addressCountry: "US",
    customerEntityCreationStatus: "",
    customerEntityUpdateStatus: "",
    formInValid: true,
}

const setAllCustomerEntity = (state = initialState, action) => {
    return updateObject(state, {
        customerEntities: action.data
    });
};

const setCustomerEntityDetails = (state = initialState, action) => {
    const { data } = action;
    const customerEntityDetails = data;
    return updateObject(state, {
        customerEntityDetails
    });
}

const updateCustomerEntityField = (state = initialState, action) => {
    const { name, value } = action.data;
    if (state.customerEntityDetails.hasOwnProperty(name)) {
        return updateObject(state, {
            customerEntityDetails: updateObject(state.customerEntityDetails, {
                [name]: value
            })
        });
    }
    return state;
}

// const addLegalEntityRow = (state = initialState, action) => {
//     const { defaultCountryMapingRow } = action;
//     return updateObject(state, {
//         legalEntityList: [...state.legalEntityList, defaultCountryMapingRow]
//     });
// };
const addLegalEntityRow = (state = initialState, action) => {
    const { defaultCountryMapingRow } = action;
    const { customerEntityDetails } = state;
    const { legalEntityList } = customerEntityDetails;
    return updateObject(state, {
        customerEntityDetails: updateObject(state.customerEntityDetails, {
            legalEntityList: [...legalEntityList, defaultCountryMapingRow]
        })
    });
};

const setLegalEntityColumnValue = (state = initialState, action) => {
    const { columnName, columnValue, rowIndex } = action;
    const { customerEntityDetails } = state;
    const { legalEntityList } = customerEntityDetails;
    legalEntityList[rowIndex] = { ...legalEntityList[rowIndex], [columnName]: columnValue };
    return updateObject(state, {
        customerEntityDetails: updateObject(state.customerEntityDetails, {
            legalEntityList
        })
    });
};
// const deleteLegalEntityRow = (state = initialState, action) => {
//     const { rowIndex } = action;
//     const { legalEntityList } = state;
//     if (rowIndex !== -1) {
//         legalEntityList.splice(rowIndex, 1);
//     }
//     return updateObject(state, { legalEntityList });
// }
const deleteLegalEntityRow = (state = initialState, action) => {
    const { rowIndex } = action;
    const { customerEntityDetails } = state;
    const { legalEntityList } = customerEntityDetails;
    if (rowIndex !== -1) {
        legalEntityList.splice(rowIndex, 1);
    }
    return updateObject(state, {
        customerEntityDetails: updateObject(state.customerEntityDetails, {
            legalEntityList
        })
    });
}
// const resetLegalEntityDetails = (state = initialState, action) => {
//     return updateObject(state, {
//         legalEntityList: []
//     });
// };
const resetLegalEntityDetails = (state = initialState, action) => {
    // const { customerEntityDetails } = state;
    // const { legalEntityList } = customerEntityDetails;
    // legalEntityList = [];
    return updateObject(state, {
        customerEntityDetails: updateObject(state.customerEntityDetails, {
            companyName: "",
            orgId: "",
            legalEntityList: []
        })
    });
};
const updateLegalEntityAddressField = (state = initialState, action) => {
    const { data } = action;
    return updateObject(state, {
        billingAddress: updateObject(state.billingAddress, data)
    });
    // const { data } = action;

    // const field = Object.keys(data);
    //     return updateObject(state, {
    //         billingAddress: updateObject(state.billingAddress, {
    //             billingAddress[field]: data[field]
    //         })
    //     });

    // return state;
}

const updateAddressCountry = (state = initialState, action) => {
    const { country } = action;
    return updateObject(state, {
        addressCountry: country
    });
}
const setCustomerEntityCreationStatus = (state = initialState, action) => {
    return updateObject(state, { customerEntityCreationStatus: action.data });
}

const setCustomerEntityUpdateStatus = (state = initialState, action) => {
    return updateObject(state, { customerEntityUpdateStatus: action.data });
}
const setFormInvalid = (state = initialState, action) => {
    return updateObject(state, { formInValid: action.data });
}
const reducer = (state = initialState, action) => {
    if (action.type === "SET_CUSTOMER_ENTITY_LIST") {
        return setAllCustomerEntity(state, action);
    }
    if (action.type === "UPDATE_CUSTOMER_ENTITY_FIELDS_DATA") {
        return updateCustomerEntityField(state, action);
    }
    else if (action.type === "ADD_LEGALENTITY_ROW") {
        return addLegalEntityRow(state, action);
    }
    else if (action.type === "SET_LEGALENTITY_COLUMN_VALUE") {
        return setLegalEntityColumnValue(state, action);
    }
    else if (action.type === "DELETE_LEGALENTITY_ROW") {
        return deleteLegalEntityRow(state, action);
    }
    else if (action.type === "RESET_LEGALENTITY_DATA") {
        return resetLegalEntityDetails(state, action);
    }
    else if (action.type === "SET_CUSTOMER_ENTITY_DETAILS") {
        return setCustomerEntityDetails(state, action);
    }
    else if (action.type === "UPDATE_LEGALENTITY_ADDRESS_FIELD") {
        return updateLegalEntityAddressField(state, action);
    }
    else if (action.type === "UPDATE_ADDRESS_COUNTRY") {
        return updateAddressCountry(state, action);
    }
    else if (action.type === "SET_CUSTOMERENTITY_CREATION_STATUS") {
        return setCustomerEntityCreationStatus(state, action);
    }
    else if (action.type === "SET_CUSTOMERENTITY_UPDATE_STATUS") {
        return setCustomerEntityUpdateStatus(state, action);
    }
    else if (action.type === "SET_FORM_INVALID") {
        return setFormInvalid(state, action);
    }
    return state;
};

export default reducer;